import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { updateAlert, updateModelInputTypes, updateModelResultTypes } from '../../../redux/actions';
import {
  // Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  FormControl,
  Button,
  Select,
  InputLabel,
  MenuItem
} from "@mui/material";
import { arraysEqual } from '../../../../../utils/arrayFunctions';
import UserSelect from '../../../components/SelectField/UserSelect';

function EditModel({ open, selectedModel, setOpen, reload, setReload, fullScreen, modelInputTypes, modelResultTypes, handleModelInputTypes, handleModelResultTypes, handleAlert }) {

  const [editName, setEditName] = useState(selectedModel?.name || "");
  const [editVersion, setEditVersion] = useState(selectedModel?.version || "");
  const [editDetails, setEditDetails] = useState(selectedModel?.details || "");
  const [editDataDescription, setEditDataDescription] = useState(selectedModel?.description || "");
  const [editNote, setEditNote] = useState(selectedModel?.note || "");
  const [editUsers, setEditUsers] = useState([]);
  const [editModelInputType, setEditModelInputType] = useState(1);
  const [editModelResultType, setEditModelResultType] = useState(1);
  const [editExampleFile, setEditExampleFile] = useState(selectedModel?.exampleFile || "");



  useEffect(() => {
    if (!selectedModel || !open) return;

    setEditName(selectedModel?.name || "");
    setEditVersion(selectedModel?.version || "");
    setEditDetails(selectedModel?.details || "");
    setEditDataDescription(selectedModel?.dataDescription || "");
    setEditNote(selectedModel?.note || "");
    setEditUsers(selectedModel?.users || []);
    setEditModelInputType(selectedModel?.m2dModelInputType?.id || 1);
    setEditModelResultType(selectedModel?.m2dModelResultType?.id || 1);
    setEditExampleFile(selectedModel?.exampleFile || "");

  }, [selectedModel, open]);

  useEffect(() => {
    if (modelInputTypes === null || reload) {
      axios({
        method: "get",
        url: "/api/m2d/models/getAllModelInputTypes"
      }).then((res) => {
        // setModelInputTypes(res.data);
        handleModelInputTypes(res.data);
      }).catch((err) => {
        handleAlert("error", err.message, 3000);
      })
    } else {
      // setModelInputTypes(modelInputTypes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (modelResultTypes === null || reload) {
      axios({
        method: "get",
        url: "/api/m2d/models/getAllModelResultTypes"
      }).then((res) => {
        // setModelResultTypes(res.data);
        handleModelResultTypes(res.data)
      }).catch((err) => {
        handleAlert("error", err.message, 3000);
      })
    } else {
      // setModelResultTypes(modelResultTypes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditSubmit = async () => {
    const new_uids = editUsers.map(user => user.id)
    const old_uids = selectedModel.users.map(user => user.id)

    if (
      selectedModel.m2dModelInputType && selectedModel.m2dModelResultType &&
      (editModelInputType === selectedModel.m2dModelInputType.id)
      &&
      (editModelResultType === selectedModel.m2dModelResultType.id)
      &&
      (editName === selectedModel.name || !editName)
      &&
      (editVersion === selectedModel.version || !editVersion)
      &&
      (editDetails === selectedModel.details || !editDetails)
      &&
      (editDataDescription === selectedModel.dataDescription || !editDataDescription)
      &&
      (editExampleFile === selectedModel.exampleFile)
      &&
      arraysEqual(old_uids, new_uids)

    ) {
      if (editNote) {
        handleAlert("error", "Doesn't support leaving notes for now, your note is not saved", 4000);
      }
      setOpen(false);
    } else {
      axios({
        method: "post",
        url: "/api/m2d/models/editModel",
        data: {
          mid: selectedModel.id,
          name: editName ?? selectedModel.name,
          inputTypeId: editModelInputType,
          resultTypeId: editModelResultType,
          version: editVersion ?? selectedModel.version,
          details: editDetails ?? selectedModel.details,
          dataDescription: editDataDescription ?? selectedModel.dataDescription,
          exampleFile: editExampleFile ?? selectedModel.exampleFile,
          uids: new_uids,
          needApprove: !((editName === selectedModel.name || !editName)
            &&
            (editVersion === selectedModel.version || !editVersion)
            &&
            (editDetails === selectedModel.details || !editDetails)
            &&
            (editDataDescription === selectedModel.dataDescription || !editDataDescription)
            &&
            (editExampleFile === selectedModel.exampleFile))
          // note: editNote
        }
      }).then(() => {
        handleAlert("success", "Successfully submitted!");
        setOpen(false);
        setReload(!reload);
      }).catch(err => {
        handleAlert("error", err.message, 3000);
        console.log(err);
      })
    }
  }

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleEditClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {`Edit ${selectedModel?.name}`}
        </DialogTitle>
        <DialogContent>
          <div className="proj-add-info">
            Your change will apply once we approve.
          </div>
          <UserSelect setUsers={setEditUsers} users={editUsers} sx={{ marginTop: '10px', marginBottom: '10px' }} />
          <FormControl
            fullWidth
            sx={{
              marginTop: "15px"
            }}
          >
            <InputLabel id="select-input-type" required>Input type</InputLabel>
            <Select
              labelId="select-input-type"
              value={editModelInputType}
              label="Input type"
              onChange={(e) => setEditModelInputType(e.target.value)}
            >
              {modelInputTypes?.map((it) => {
                return <MenuItem key={it.id} value={it.id}>{it.type}</MenuItem>
              })}
            </Select>
          </FormControl>

          <FormControl
            fullWidth
            sx={{
              marginTop: "15px"
            }}
          >
            <InputLabel id="select-result-type" required>Result type</InputLabel>
            <Select
              labelId="select-result-type"
              value={editModelResultType}
              label="Result type"
              onChange={(e) => setEditModelResultType(e.target.value)}
            >
              {modelResultTypes?.map((rt) => {
                return <MenuItem key={rt.id} value={rt.id}>{rt.type}</MenuItem>
              })}
            </Select>
          </FormControl>
          <TextField
            required
            label="Name"
            fullWidth
            margin="normal"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
          />

          <TextField
            required
            label="Version"
            fullWidth
            margin="normal"
            value={editVersion}
            onChange={(e) => setEditVersion(e.target.value)}
          />

          <TextField
            required
            label="Details"
            fullWidth
            margin="normal"
            value={editDetails}
            multiline
            minRows={3}
            maxRows={5}
            onChange={(e) => setEditDetails(e.target.value)}
          />

          <TextField
            required
            label="Data Description"
            fullWidth
            margin="normal"
            value={editDataDescription}
            multiline
            minRows={3}
            maxRows={5}
            onChange={(e) => setEditDataDescription(e.target.value)}
          />

          <TextField
            required
            label="Example file"
            fullWidth
            margin="normal"
            value={editExampleFile}
            onChange={(e) => setEditExampleFile(e.target.value)}
          />

          <TextField
            label="Note"
            placeholder="Leave a note if you have other requests"
            fullWidth
            multiline
            minRows={3}
            maxRows={5}
            margin="normal"
            value={editNote}
            onChange={(e) => setEditNote(e.target.value)}
          />

        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleEditClose}>
            Discard
          </Button>
          <Button variant="contained" type="primary" onClick={handleEditSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    modelInputTypes: state.m2d.modelInputTypes,
    modelResultTypes: state.m2d.modelResultTypes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleModelInputTypes(modelInputTypes) {
      updateModelInputTypes(modelInputTypes)(dispatch)
    },

    handleModelResultTypes(modelResultTypes) {
      updateModelResultTypes(modelResultTypes)(dispatch)
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditModel);
